import { jsx as _jsx } from "react/jsx-runtime";
import * as ReactMarkdown from 'react-markdown';
import { Blockquote } from './components/Blockquote';
import { Code } from './components/Code';
import { Heading } from './components/Heading';
import { Image } from './components/Image';
import { InlineLink } from './components/InlineLink';
import { List } from './components/List';
import { Paragraph } from './components/Paragraph';
import { StandaloneLink } from './components/StandaloneLink';
import { Blockquote as BlockquotePlugin, BLOCKQUOTE_PLUGIN_ID } from './plugins/Blockquote';
import { List as ListPlugin, LIST_PLUGIN_ID } from './plugins/List';
import { StandaloneLink as StandaloneLinkPlugin, STANDALONE_LINK_PLUGIN_ID } from './plugins/StandaloneLink';
import { allowNode } from './utils';
export var Markdown = function (_a) {
  var _b;
  var _c = _a.markdown,
    markdown = _c === void 0 ? '' : _c;
  return _jsx(ReactMarkdown, {
    allowNode: allowNode,
    plugins: [BlockquotePlugin, ListPlugin, StandaloneLinkPlugin],
    disallowedTypes: ['definition', 'html', 'imageReference', 'linkReference', 'table', 'tableCell', 'tableRow'],
    renderers: (_b = {
      code: Code,
      heading: Heading,
      image: Image,
      inlineCode: Code,
      link: InlineLink,
      paragraph: Paragraph
    }, _b[BLOCKQUOTE_PLUGIN_ID] = Blockquote, _b[LIST_PLUGIN_ID] = List, _b[STANDALONE_LINK_PLUGIN_ID] = StandaloneLink, _b),
    // NOTE: this prop is deprecated and replaced by `urlTransform` since v9 of
    // `react-markdown`.
    transformLinkUri: function (uri) {
      if (uri.startsWith('blob:')) return uri;
      return ReactMarkdown.uriTransformer(uri);
    },
    children: markdown
  });
};